<div class="c-homegrid">
  @for (tile of tiles(); track tile.id) {
    <a class="c-homegrid__tile" [routerLink]="tile.route">
      <i class="c-homegrid__icon {{ tile.icon }}" aria-hidden="true"></i>
      <span class="c-homegrid__label">{{ tile.labelKey | translate }}</span>
    </a>
  }
</div>
